import { render, staticRenderFns } from "./UserViewLogs.vue?vue&type=template&id=e795654e"
import script from "./UserViewLogs.vue?vue&type=script&lang=js"
export * from "./UserViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports